import { usePaymentServices } from '../../common/services';

interface Item {
  date: string;
  params: string;
}

const UTM_PARAM_VALID_DAYS = 30;

function daysToMillis(days: number) {
  return days * 24 * 60 * 60 * 1000;
}

export function useGetUtmParameters(): string | null {
  const { localStorage } = usePaymentServices();
  const item = localStorage.getItem<Item>('utm_params');
  if (item) {
    if (Date.now() - new Date(item.date).getTime() < daysToMillis(UTM_PARAM_VALID_DAYS)) {
      return item.params;
    }
  }
  return null;
}
